import { useOktaAuth } from '@okta/okta-react';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Button, Heading, Text, VStack, Center } from '@chakra-ui/react';
import PulseLoader from "react-spinners/PulseLoader";
import { useTranslation } from 'react-i18next';

const ManagerPasswordReset = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  // Extract validation data from location state
  const { authState, oktaAuth } = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);
  const [validationData, setValidationData] = useState(location.state?.validationData || null);
  const [loading, setLoading] = useState(false);
  const [buttonClickable, setButtonClickable] = useState(true);
  const [apiResponse, setApiResponse] = useState(null);
  const [passwordRestComplete, setPasswordRestComplete] = useState(false);
  const [secondaryEmail, setSecondaryEmail] = useState(location.state?.validationData?.external_email || null);

  useEffect(() => {

    if (!authState || !authState.isAuthenticated) {
      // When user isn't authenticated, forget any user info
      setUserInfo(null);
      setValidationData(null);
    } else {
      oktaAuth.getUser().then((info) => {
        setUserInfo(info);
      });
      console.log(validationData);
    }
  }, [authState, oktaAuth]); // Update if authState changes

  // Function to handle the password reset API call
  function handleClick(value) {
    setLoading(true);
    fetch(value.next, {
      method: 'POST',
      body: JSON.stringify({
        user: value.target_user,
        sessionid: value.session_id,
        locale: "en_US"
      }),
      headers: {
        Authorization: 'Bearer ' + authState.accessToken.accessToken
      }
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.statusCode && data.statusCode !== 200) {
          navigate('/Error', { state: { errorMessage: data.message } });
        } else {
          setApiResponse(data);
          setButtonClickable(false);
          setPasswordRestComplete(true);
          setLoading(false);
        }
      }).catch(error => {
        navigate('/Error', { state: { errorMessage: error.message } });
      });
  };

  if (!authState) {
    oktaAuth.signInWithRedirect({ originalUri: '/' });
    return (
      <div>Loading...</div>
    );
  }

  if (!validationData) {
    return (
      <Box>{t('error')}: {t('No validation data available')}</Box>
    );
  }

  return (
    <Box id="home">
      {loading &&
        <Box className="sweet-loading">
          <Box className="centered">
            <PulseLoader
              loading={loading}
              color="#dadada"
              size={30}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </Box>
        </Box>
      }
      <Box>
        { authState.isAuthenticated && !userInfo
        && <Box>{t('Loading user information')}...</Box>}

        {authState.isAuthenticated && userInfo && !passwordRestComplete
        && (
          <Center>
            <VStack spacing={6} width="100%">
              <Heading as="h1" size="2xl">{t('Identity Verification Successful')}</Heading>
              <Box p={8} borderWidth="1px" borderRadius="lg" bg="white" shadow="sm" width="100%">
                <Text mb={6} fontSize="lg">
                  {t("manager_password_reset_message", { target_user: validationData.target_user, secondaryEmail: secondaryEmail })}
                </Text>
                <Center>
                  <Button 
                    colorScheme="gray" 
                    size="lg" 
                    isDisabled={!buttonClickable} 
                    onClick={() => handleClick(validationData)}
                  >
                    {t('Send Password Reset Email')}
                  </Button>
                </Center>
              </Box>
            </VStack>
          </Center>
        )}
        {authState.isAuthenticated && userInfo && passwordRestComplete
        && (
          <Center>
            <VStack spacing={6} width="100%">
              <Heading as="h1" size="2xl">{t('Password Reset Message Sent')}</Heading>
              <Box p={8} borderWidth="1px" borderRadius="lg" bg="white" shadow="sm" width="100%">
                <Heading as="h3" size="md" mb={4}>
                  {apiResponse.message}
                </Heading>
                <Text>
                  {t('Please close your web browser to end this session.')}
                </Text>
              </Box>
            </VStack>
          </Center>
        )}
      </Box>
    </Box>
  );
};
export default ManagerPasswordReset;
